import RouletteScreen from "./screens/RouletteScreen";
import ExchangeScreen from "./screens/ExchangeScreen";
import WinScreen from "./screens/WinScreen";
import CompleteScreen from "./screens/CompleteScreen";

import { useState } from "react";

function App() {
  const [winnerType, setWinnerType] = useState(null);
  const [isChangeble, setIsChangeble] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  if (isComplete) {
    return <CompleteScreen />;
  }

  if (isChangeble.access) {
    return <ExchangeScreen exchangeType={isChangeble.result} setIsComplete={setIsComplete} />;
  }

  if (winnerType) {
    return <WinScreen type={winnerType} />;
  }

  return (
    <div className="App">
      <RouletteScreen
        isChangeble={isChangeble}
        setWinnerType={setWinnerType}
        setIsChangeble={setIsChangeble}
      />
    </div>
  );
}

export default App;
